/**
 * Restituisce un colore CSS in base al livello di confidenza.
 * Soglie allineate con vspot_shared/constants.py.
 */
export function getConfidenceColor(confidence: number): string {
  if (confidence >= 0.90) return '#22c55e'; // green
  if (confidence >= 0.70) return '#eab308'; // yellow
  if (confidence >= 0.50) return '#f97316'; // orange
  return '#ef4444'; // red (very low)
}

/**
 * Restituisce una label testuale per il livello di confidenza.
 */
export function getConfidenceLevel(confidence: number): string {
  if (confidence >= 0.90) return 'Alta';
  if (confidence >= 0.70) return 'Media';
  if (confidence >= 0.50) return 'Bassa';
  return 'Molto bassa';
}